import {KVPair, ListPage, Loss} from "../models/types";
import {restapi} from "./restapi";

export function deleteLoss(data: Loss): Promise<boolean> {
    return restapi.delete<void>(`/api/v1/smt_core/loss/${data.id}/`).then(res => res.status === 204);
}

export function saveLoss(data: Loss): Promise<Loss> {
    if (!data.id) {
        return restapi.post<Loss>('/api/v1/smt_core/loss/', data).then((res) => res.data);
    } else {
        return restapi.patch<Loss>(`/api/v1/smt_core/loss/${data.id}/`, data).then((res) => res.data);
    }
}

export function getLosses(pageNumber = 1, pageSize?: number, filters?: KVPair[], sorting?: string[]): Promise<ListPage<Loss>> {
    const params = new URLSearchParams();
    params.append('page', pageNumber.toString());
    if (pageSize) {
        params.append('page_size', pageSize.toString());
    }
    if (filters) {
        filters.forEach((filter) => {
            const key = filter.key as string;
            const value = filter.value as string;
            params.append(key, value);
        });
    }
    if (sorting) {
        params.append('ordering', sorting.join(','));
    }
    return restapi.get<ListPage<Loss>>(`/api/v1/smt_core/loss/?${params.toString()}`).then((res) => res.data);
}

export function bulkDeleteLosses(lossIds: number[]): Promise<boolean> {
    const promises = lossIds.map(id => restapi.delete<void>(`/api/v1/smt_core/loss/${id}/`));
    return Promise.all(promises).then(results => results.every(res => res.status === 204));
}
